import React from "react";
import "./WhatWeBelieve.css";
import image1 from '../assets/WhatWeBelieve/believe1.png';
import image2 from '../assets/WhatWeBelieve/believe2.png';

const WhatWeBelieve = () => {
  return (
    <section className="belief-section">
     <div className="belief-images">
      <div className="single-image">
        <img src={image1} alt="Donation" />
      </div>

      <div className="single-image lower-image">
        <img src={image2} alt="Teamwork" />
      </div>
     </div>
      <div className="belief-text">
        <h1>What we believe</h1>
        <p>
          This year we helped nearly 1000 people to build better future in India. Regular donation saves lives. Your support will help us in changing world. Every donation you make helps us bring food, education, medical care, and the love of Christ to those in need.
        </p>
      </div>
    </section>
  );
};

export default WhatWeBelieve;
